const angular = require('angular');

const { onBoardingComponentDefinition } = require('./onboarding-dialog.component');
const { onBoardingContentComponentDefinition } = require('./onboarding-dialog-content.component');
const onBoardingService = require('./onboarding.service');

angular.module('wowApp.shop')
    .service('OnBoardingService', onBoardingService)
    .component('wowOnBoardingDialog', onBoardingComponentDefinition)
    .component('wowOnBoardingContentDialog', onBoardingContentComponentDefinition);




// WEBPACK FOOTER //
// ./src/shop/onboarding/index.js